module.exports = __webpack_public_path__ + "img/hawk.c5ca241f.png";